import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import { ProtectedRoute } from './routes/ProtectedRoutes'
import { protectedRoutes, publicRoutes } from './routes/routes'
import { useDomainTheme } from '@/entities/domain'
import { Suspense } from 'react'

function App() {
  useDomainTheme()
  return (
    <div className="flex flex-col justify-evenly items-center dark:bg-dark-bg border-light-bg min-h-screen">
      <Router>
        <Suspense
          fallback={<div className="flex items-center justify-center h-screen">Loading...</div>}
        >
          <Routes>
            {publicRoutes.map(({ path, element }, index) => (
              <Route key={index} path={path} element={element} />
            ))}

            {protectedRoutes.map(({ path, element, children }, index) => (
              <Route key={index} path={path} element={<ProtectedRoute>{element}</ProtectedRoute>}>
                {children?.map(
                  ({ path: childPath, element: childElement, index: isIndex }, idx) => (
                    <Route key={idx} path={childPath} element={childElement} index={isIndex} />
                  )
                )}
              </Route>
            ))}
          </Routes>
        </Suspense>
      </Router>
    </div>
  )
}

export default App
